import {Injectable} from "@angular/core";
import {UrlBuilder} from "../url-builder/url.builder";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ComplexDevices} from "./complexDevices";


@Injectable({
  providedIn: 'root'
})
export class ComplexDevicesDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<ComplexDevices> {
    this.uiUrl = this.url.GetComplexDevicesUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<ComplexDevices>(this.uiUrl);
  }

}


